import { ReactNode } from 'react';

interface KPICardProps {
  title: string;
  value: string;
  subtitle?: string;
  change?: number;
  changeLabel?: string;
  icon: string;
  iconBg: string;
  iconColor: string;
  children?: ReactNode;
}

export default function KPICard({ title, value, subtitle, change, changeLabel, icon, iconBg, iconColor, children }: KPICardProps) {
  return (
    <div className="bg-white rounded-xl border border-background-200 p-5 flex flex-col gap-3 hover:border-background-300 transition-colors">
      <div className="flex items-start justify-between">
        <div className="flex flex-col gap-1">
          <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">{title}</span>
          <span className="text-2xl font-bold text-foreground-900 tracking-tight">{value}</span>
          {subtitle && <span className="text-xs text-foreground-500">{subtitle}</span>}
        </div>
        <div className={`w-10 h-10 rounded-xl ${iconBg} flex items-center justify-center flex-shrink-0`}>
          <i className={`${icon} ${iconColor} text-lg`}></i>
        </div>
      </div>
      {change !== undefined && (
        <div className="flex items-center gap-1.5">
          <span className={`inline-flex items-center gap-0.5 text-xs font-semibold ${change >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
            <i className={`${change >= 0 ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-xs`}></i>
            {Math.abs(change)}%
          </span>
          {changeLabel && <span className="text-xs text-foreground-500">{changeLabel}</span>}
        </div>
      )}
      {children}
    </div>
  );
}